module.exports = __webpack_public_path__ + "assets/stars.8806eb1ee65850420b4fd82422e30e62.svg";